import React, { Component } from "react";
import { BrowserRouter as Router, Switch, withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import SplitPane from "react-split-pane";
import { Grid, CircularProgress } from "@material-ui/core";
import Header from "layout/header/Header";
import Navigation from "layout/navigation/Navigation";
import { styles } from "./Home.css";
import { connect } from "react-redux";
import { loginSSOUser } from "../../redux/actions/UserActions";
import { redirectMessageOpen } from "../../modules/messages/redux/MessagesActions";
import { loadRuntime } from "../../redux/actions/OrgRuntimeActions";
import clsx from "clsx";
import { Route, Redirect } from "react-router-dom";

const MlAllNewsRouting = React.lazy(() =>
  import("../../modules/ml-all-news/Routing")
);

const MlAllNewsPopupRouting = React.lazy(() =>
  import("../../modules/ml-all-news/PopupRouting")
);
//dynamic on permission
const PlaylistRouting = React.lazy(() =>
  import("../../modules/ml-playlist/Routing")
);

const PlaylistPopupRouting = React.lazy(() =>
  import("../../modules/ml-playlist/PopupRouting")
);
const SmSysAdminRouting = React.lazy(() =>
  import("modules/sm-sys-admin/Routing")
);
const SmSysAdminPopupRouting = React.lazy(() =>
  import("modules/sm-sys-admin/PopupRouting")
);

const MlAdminRouting = React.lazy(() =>
  import("../../modules/ml-admin/Routing")
);
const MlAdminPopupRouting = React.lazy(() =>
  import("../../modules/ml-admin/PopupRouting")
);

const MlLicensingAdminRouting = React.lazy(() =>
  import("../../modules/ml-licensing-admin/Routing")
);
const MlLicensingRouting = React.lazy(() =>
  import("../../modules/ml-licensing/Routing")
);
const MlLicensingAdminPopupRouting = React.lazy(() =>
  import("../../modules/ml-licensing-admin/PopupRouting")
);
const MlLicensingPopupRouting = React.lazy(() =>
  import("../../modules/ml-licensing/PopupRouting")
);

const MLTrackRouting = React.lazy(() =>
  import("modules/ml-music-search/Routing")
);

const MLTrackPopupRouting = React.lazy(() =>
  import("modules/ml-music-search/PopupRouting")
);

const InboxRouting = React.lazy(() => import("modules/inbox/Routing"));

const InboxPopupRouting = React.lazy(() =>
  import("modules/inbox/PopupRouting")
);

const SMLibraryRouting = React.lazy(() => import("modules/sm-admin/Routing"));

const SMLibraryPopupRouting = React.lazy(() =>
  import("modules/sm-admin/PopupRouting")
);

const MLContnetAdminRouting = React.lazy(() =>
  import("modules/ml-content-admin/Routing")
);

const MLContnetAdminPopupRouting = React.lazy(() =>
  import("modules/ml-content-admin/PopupRouting")
);

const SMWorkspaceRouting = React.lazy(() =>
  import("modules/sm-workspace/Routing")
);

const SmLogRouting = React.lazy(() => import("../../modules/sm-log/Routing"));
const SmLogPopupRouting = React.lazy(() =>
  import("../../modules/sm-log/PopupRouting")
);

const SmReportsRouting = React.lazy(() =>
  import("../../modules/sm-reports/Routing")
);
const SmReportPopupRouting = React.lazy(() =>
  import("../../modules/sm-reports/PopupRouting")
);

const TrackUploadRouting = React.lazy(() =>
  import("../../modules/ml-track-upload/Routing")
);

const DownloaderRouting = React.lazy(() =>
  import("../../modules/ml-downloader/Routing")
);

const TrackUploadPopupRouting = React.lazy(() =>
  import("../../modules/ml-track-upload/PopupRouting")
);
const PlayOutRouting = React.lazy(() =>
  import("../../modules/ml-playout/Routing")
);

const PlayOutPopupRouting = React.lazy(() =>
  import("../../modules/ml-playout/PopupRouting")
);

const ContentTrackerRouting = React.lazy(() =>
  import("../../modules/ml-content-tracker/Routing")
);

const ContentTrackerPopupRouting = React.lazy(() =>
  import("../../modules/ml-content-tracker/PopupRouting")
);

const NoPermission = React.lazy(() =>
  import("../../modules/no-permission/Routing")
);

class Home extends Component {
  constructor(props) {
    super();
    this.state = {
      handle: props.match.params.handle,
      orgRuntimeLoading: null,
    };
  }

  componentDidMount() {
    const { handle } = this.state;
    const {
      redirectMessageOpen,
      loadRuntime,
      orgRuntime: {
        runtime: { _trackFields },
      },
    } = this.props;
    // loadRuntime();
    if (handle) {
      const { loginSSOUser } = this.props;
      loginSSOUser(handle, this.props.history);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const q = decodeURIComponent(urlParams.get("next"));
    if (this.props.location.pathname == "/" && q == "inbox") {
      redirectMessageOpen();
    }
  }

  isCurrentPathSearch = () => {
    if (
      this.props &&
      this.props.location &&
      (this.props.location.pathname == "/search/albums" ||
        this.props.location.pathname == "/search/tracks" ||
        this.props.location.pathname == "/search" ||
        this.props.location.pathname == "/mladmin/trackranking" ||
        this.props.location.pathname == "/mladmin/albumranking")
    ) {
      return true;
    } else {
      return false;
    }
  };

  componentDidUpdate() {
    const {
      loadRuntime,
      orgRuntime: {
        runtime: { _trackFields },
      },
    } = this.props;
    // if(_trackFields == {}){
    //   loadRuntime();
    // }
  }

  render() {
    const {
      classes,
      loadRuntime,
      trackTagCloud: { open: trackTagOpen },
      albumTagCloud: { open: albumTagOpen },
      user: { previewVisible, navExapnded },
      location: { search, pathname },
      orgRuntime: { loading },
    } = this.props;

    const { handle, orgRuntimeLoading } = this.state;
    return (
      <Router basename="">
        {handle ? (
          <div>
            <CircularProgress />
          </div>
        ) : (
          <div className="container">
            <Switch>
              <SplitPane split="horizontal" minSize="200px">
                <SplitPane split="vertical">
                  <Grid container>
                    <Grid container>
                      <Header />
                    </Grid>

                    <Grid container>
                      <div className={classes.mainContainer} role="main">
                        <Grid container>
                          <div
                            className={
                              search.includes("?uploadTracks") ||
                              (pathname && pathname.includes("/downloader/"))
                                ? classes.naviLinksHide
                                : !navExapnded
                                ? (classes.mainwrap, classes.naviLinks)
                                : (classes.mainwrap,
                                  classes.naviLinks,
                                  classes.naviLinksCollpsed)
                            }>
                            <h2 className={classes.hideText}>Main Menu</h2>
                            <Navigation />
                          </div>
                          <div
                            className={
                              search.includes("?uploadTracks") ||
                              (pathname && pathname.includes("/downloader/"))
                                ? clsx(
                                    classes.mainwrapRightHide,
                                    classes.mainwrap
                                  )
                                : navExapnded && previewVisible
                                ? clsx(
                                    classes.mainwrap,
                                    classes.mainwrapExpanded
                                  )
                                : navExapnded && !previewVisible
                                ? clsx(
                                    classes.mainwrap,
                                    classes.mainwrapCollpsed
                                  )
                                : !navExapnded && !previewVisible
                                ? clsx(
                                    classes.mainwrap,
                                    classes.mainwrapRightCollpsed
                                  )
                                : navExapnded && previewVisible
                                ? clsx(
                                    classes.mainwrap,
                                    classes.mainwrapLeftCollpsed
                                  )
                                : classes.mainwrap
                            }>
                            <Route exact path="/">
                              <Redirect to="/search/tracks" />
                            </Route>
                            {/*  Redirect to /pl-promo if root */}
                            <MlAllNewsRouting />
                            <PlaylistRouting />
                            <MlAdminRouting />
                            <SmSysAdminRouting />
                            <MlLicensingAdminRouting />
                            <MLTrackRouting />
                            <SMLibraryRouting />
                            <MlLicensingRouting />
                            <SMWorkspaceRouting />
                            <MLContnetAdminRouting />
                            <SmLogRouting />
                            <SmReportsRouting />
                            <TrackUploadRouting />
                            <DownloaderRouting />
                            <PlayOutRouting />
                            <ContentTrackerRouting />
                            <NoPermission />
                          </div>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>

                  {(previewVisible ||
                    (this.isCurrentPathSearch() && trackTagOpen) ||
                    albumTagOpen) && (
                    <Grid initialSize="20%" minSize="20%" maxSize="300px">
                      <Paper className={classes.paper}>
                        <MlAllNewsPopupRouting />
                        <PlaylistPopupRouting />
                        <MlAdminPopupRouting />
                        <SmSysAdminPopupRouting />
                        <MlLicensingAdminPopupRouting />
                        <MLTrackPopupRouting />
                        {/* <InboxPopupRouting /> */}
                        <SMLibraryPopupRouting />
                        <MlLicensingPopupRouting />
                        <MLContnetAdminPopupRouting />
                        <SmLogPopupRouting />
                        <SmReportPopupRouting />
                        <TrackUploadPopupRouting />
                        <PlayOutPopupRouting />
                        <ContentTrackerPopupRouting />
                      </Paper>
                    </Grid>
                  )}
                </SplitPane>
              </SplitPane>
            </Switch>
          </div>
        )}
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  trackTagCloud: state.mltracklibrary.tagCloud,
  albumTagCloud: state.mlalbum.tagCloud,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, { loginSSOUser, redirectMessageOpen, loadRuntime })(
  withRouter(withStyles(styles)(Home))
);